<template>
  <div class="loading-spinner" />
</template>

<script>
export default {
  name: "LoadingSpinner",
};
</script>

<style lang="scss" scoped>
@import "@/style/variables.scss";
@import "@/style/mixins.scss";

.loading-spinner {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 5px solid rgba(255, 255, 255, 0.4);
  border-right: 5px solid $orange;
  animation: rotate360 0.5s infinite linear;
  z-index: 5;

  @keyframes rotate360 {
    100% {
      transform: rotate(360deg);
    }
  }
}
</style>
